export default {
    language: 'de-DE',
    navigation: 'Zurück',
    home: {
        title: 'Yacht Farbberechnung',
        subtitle:
            'Wir helfen Ihnen bei der Auswahl des richtigen Antifouling-Systems für Ihr Boot und berechnen die erforderliche Menge.',
        findProduct: 'Produkt finden',
        calculateVolume: 'Volumen berechnen'
    },
    find: {
        questions: {
            type: 'Boots<strong>typ</strong>?',
            material: 'Boots<strong>material</strong>?',
            sailFrequency: '<strong>Wie oft</strong>nutzen Sie Ihr Boot?',
            paintLocation: '<strong>Wo</strong>  streichen Sie Ihr Boot?',
            waterType: 'In welcher <strong>Art von Wasser</strong> benutzen Sie Ihr Boot?'
        },
        answers: {
            help: 'Benötigen Sie Hilfe bei der Antifouling-Auswahl?',

            type: [
                {
                    label: 'Segelboot',
                    icon: 'sailingBoat',
                    value: 'sailing'
                },
                {
                    label: 'Motorboot (langsam)',
                    sublabel: 'bis zu 20 Knoten',
                    icon: 'motorboatSlow',
                    value: 'motor-slow'
                },
                {
                    label: 'Motorboot (schnell)',
                    sublabel: 'schneller als 20 Knoten',
                    icon: 'motorboatFast',
                    value: 'motor-fast'
                }
            ],
            material: [
                {
                    label: 'GFK',
                    value: 'plastic'
                },
                {
                    label: 'Eisen',
                    value: 'iron'
                },
                {
                    label: 'Holz',
                    value: 'wood'
                },
                {
                    label: 'Aluminum',
                    value: 'aluminium'
                }
            ],
            sailFrequency: [
                {
                    label: 'Selten',
                    sublabel: '1-2 mal pro Monat oder seltener',
                    value: 'low'
                },
                {
                    label: 'Oft',
                    sublabel: '1-2 mal pro Woche',
                    value: 'medium'
                },
                {
                    label: 'Sehr oft',
                    sublabel: 'Fast jeden Tag',
                    value: 'high'
                }
            ],
            paintLocation: [
                {
                    label: 'Land auswählen',
                    countries: [
                        { label: 'UK', value: 'en-GB' },
                        { label: 'US', value: 'en-US' },
                        { label: 'Kanada', value: 'en-CA' },
                        { label: 'Dänemark', value: 'da-DK' },
                        { label: 'Spanien', value: 'es-ES' },
                        { label: 'Finnland', value: 'fi-FI' },
                        { label: 'Deutschland', value: 'de-DE' },
                        { label: 'Griechenland', value: 'el-GR' },
                        { label: 'Kroatien', value: 'hr-HR' },
                        { label: 'Norwegen', value: 'nb-NO' },
                        { label: 'Niederlande', value: 'nl-NL' },
                        { label: 'Schweden - Ostküste', value: 'sv-SE_e' },
                        { label: 'Schweden - Westküste', value: 'sv-SE_w' },
                        { label: 'Schweden - See', value: 'sv-SE_l' }
                    ]
                }
            ],
            waterType: [
                { label: 'das Meer/der Ozean', value: 'sea/ocean' },
                { label: 'der Fluss', value: 'rivers' },
                { label: 'Der See', value: 'lakes' }
            ]
        },
        result: {
            heading: 'Wir empfehlen',
            selection: {
                title: 'Ihre Auswahl',
                type: 'Bootstyp',
                waterType: 'Wassertyp',
                material: 'Bootsmaterial',
                sailFrequency: 'Aktivität',
                country: 'Land'
            },
            category: {
                premium: 'Premium',
                alternative: 'Biocide-free Premium',
                bestBuy: 'Bester-Kauf',
                economic: 'Economic',
                bestBuyAlternative: 'Biocide-free Bester-Kauf',
                economicAlternative: 'Biocide-free Economic'
            },
            findOutMore: 'Mehr',
            whereToBuy: 'Händler',
            email: 'E-Mail-Addresse',
            send: 'Senden',
            feedback: {
                title: 'War diese Information hilfreich?',
                yes: 'Ja',
                no: 'Nein',
                comment: 'Kommentar',
                placeholder: 'Kommentar'
            },
            recommendation: {
                title: 'Empfehlung per E-Mail senden'
            },
            calculateVolume: 'Volumen berechnen'
        }
    },
    calculate: {
        letsCalculate: 'Berechnung',
        questions: {
            antifouling: 'Wählen Sie Antifouling',
            keelType: 'Kiel<strong>art</strong>?',
            dimensions: 'Boots<strong>größe</strong>'
        },
        answers: {
            keelType: [
                {
                    label: 'Kielschwert',
                    icon: 'finKeel',
                    value: 'fin'
                },
                {
                    label: 'Ballastkiel',
                    icon: 'fullKeel',
                    value: 'full'
                }
            ],
            dimensionTitles: [
                {
                    title: 'Individuelle Maße'
                },
                {
                    title: 'ODER Unterwasserfläche in m2'
                }
            ],
            dimensions: [
                {
                    type: 'unit',
                    label: 'Einheit',
                    values: [{ label: 'Meters', value: 'm' }, { label: 'Feet', value: 'f' }],
                    valuesUS: [{ label: 'Feet', value: 'f' }, { label: 'Meters', value: 'm' }]
                },
                {
                    type: 'waterline',
                    label: 'Länge der Wasserlinie'
                },
                {
                    type: 'beam',
                    label: 'Schiffsbreite'
                },
                {
                    type: 'draft',
                    label: 'Tiefgang'
                },
                {
                    type: 'm2',
                    label: 'm2'
                }
            ]
        },
        result: {
            heading: 'Erforderliches Volumen',
            selection: {
                title: 'Ihre Auswahl',
                antifouling: 'Antifouling',
                type: 'Bootstyp',
                material: 'Bootsmaterial',
                sailFrequency: 'Aktivität',
                country: 'Land',
                keelType: 'Kielart',
                dimensions: 'Boot Dimension'
            },
            category: {
                premium: 'Premium',
                alternative: 'Biocide-free Premium',
                bestBuy: 'Bester-Kauf',
                economic: 'Economic',
                bestBuyAlternative: 'Biocide-free Bester-Kauf',
                economicAlternative: 'Biocide-free Economic'
            },
            suggestedAmount: 'Empfohlene Menge',
            suggestedAmountTwoCoats: 'Empfohlene Menge (2 Schichten)',
            oneCoat: '(1 Schicht)',
            fiveCoats: '(5 Schichten)',
            primerAltTiecoatSilic: 'Bitte vergessen Sie nie, vorher den Tiecoat zu verwenden!',
            primerAltSilicSealSilic:
                '<strong>FALL 2</strong></br>Überstreichen eines vorhandenen Antifouling (guter Zustand) – problemloser Wechsel zu Silic One System',
            primerAlLightSilic:
                '<strong>FALL 1</strong></br>Entfernen des alten Antifoulings und Anwendung des kompletten Systems & Neues Boot ohne Epoxid',

            primerAltTiecoat:
                '<strong>FALL 2: Schritt 2</strong></br>… und dann eine Schicht Conversion Primer.',
            primerAltSilicSeal:
                '<strong>FALL 2: Schritt 1</strong></br>Bei Booten ohne Antifouling zuerst eine Schicht Light Primer auftragen... ',
            primerAlLight:
                '<strong>FALL 1</strong></br>Auftragen auf altes Antifouling in gutem Zustand',
            primer:
                'Ist der Rumpf des Bootes stark beschädigt oder streichen Sie Ihr Boot zum ersten Mal? Sie benötigen...',
            whereToBuy: 'Händler',
            email: 'E-Mail-Addresse',
            send: 'Senden',
            or: 'ODER',
            feedback: {
                title: 'War diese Information hilfreich?',
                yes: 'Ja',
                no: 'Nein',
                comment: 'Kommentar',
                placeholder: 'Kommentar'
            },
            recommendation: {
                title: 'Empfehlung per E-Mail senden'
            },
            calculateVolume: 'Volumen berechnen'
        }
    },
    map: {
        country: 'Land',
        city: 'Stadt',
        getDirections: 'Gebrauchsanleitung',
        placeholder: 'Alle Gebiete...'
    },
    footer: 'Hempel Yacht – Alles, was Sie über Yacht-Beschichtungen wissen müssen'
}
